import React, { Children, useEffect, useState } from "react";
import Layout from "../../Layout/Layout";
import moment from "moment";
import { DATE_FORMAT_MOMENT } from "../../Helper/Constants";
import ModalCustom from "../../Layout/ModalCustom";
import { CallApiGet, CallApiPost } from "../../Helper/serviceApi";
import BankSlipDetailes from "./BankSlipDetailes";
import BankSlipList from "./BankSlipList";
import GetSvgIcon from "../../../images/svglist";
import { Tooltip } from "react-tooltip";
import { useSearchParams } from "react-router-dom";
import { Modal, Toast } from "react-bootstrap";

const initAlertConfig = {
  isSuccess: false,
  size: "",
  show: false,
  title: "",
  description: "",
};
const initialModalConfig = {
  show: false,
  title: "",
  size: "sm",
  data: [],
};
export const initErrObj = {
  invAmt: {
    value: false,
    message: "",
  },
  cnAmt: {
    value: false,
    message: "",
  },
  advAmt: {
    value: false,
    message: "",
  },
  bnkAmt: {
    value: false,
    message: "",
  },
};

const BankSlipMain = () => {
  const [spinner, setSpinner] = useState(false);
  const [alertConfig, setAlertConfig] = useState(
    Object.assign({}, initAlertConfig)
  );
  const [openModalConfig, setOpenModalConfig] = useState(
    Object.assign({}, initialModalConfig)
  );
  const [bsList, setBsList] = useState([]);
  const [isAppovedClicked, setIsAppovedClicked] = useState(false);
  const [selectedBs, setSelectedBs] = useState();
  let selectedBs2;
  const [footerButton, setFooterButton] = useState();
  const [invoiceList, setInvoiceList] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [creditNoteApplied, setCreditNoteApplied] = useState(false);
  const [finalAmount, setFinalAmount] = useState();
  const [isRemarkBlank, setIsRemarkBlank] = useState(false);
  const [errorObj, setErrorObj] = useState(
    JSON.parse(JSON.stringify(initErrObj))
  );
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const custConditionalStyle2 = [
    {
      when: (row) => row.statusId === 811,
      style: {
        color: "#00964b",
        fontWeight: 500,
      },
    },
    {
      when: (row) => row.statusId === 812,
      style: {
        color: "red",
        fontWeight: 500,
      },
    },
    {
      when: (row) => row.statusId === 810,
      style: {
        color: "#f5c30f",
        fontWeight: 500,
      },
    },
  ];
  const bsCols = [
    {
      name: "Upload Date",
      selector: (row) =>
        !!row?.date ? moment(row?.date).format(DATE_FORMAT_MOMENT) : "",
      sortable: true,
      filterable: true,
      // omit: hideColums,
      //
    },
    {
      name: "Customer",
      selector: (row) => row?.custName,
      sortable: true,
      filterable: true,
      // omit: hideColums,
    },
    {
      name: "Invoices",
      selector: (row) => row?.invoices,
      cell: (row) => (
        <>
          <pre className="box-text p-1">
            <span className="d-inline-block">{row?.invoices}</span>
          </pre>
        </>
      ),
      // sortable: true,
      filterable: true,
      // omit: hideColums,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      filterable: true,
      conditionalCellStyles: custConditionalStyle2,
    },
    {
      name: "",
      cell: (row) => (
        <>
          <div
            data-tooltip-id={"inv-" + row?.ref_no + row?.trans_date}
            className="me-3"
            onClick={() => handelActionButtonClick(row)}
          >
            {GetSvgIcon("EditPencil")}
          </div>
          <Tooltip id={"inv-" + row.ref_no} content="Action" place="left" />
        </>
      ),
      allowOverflow: true,
      button: true,
      width: "56px",
    },
  ];
  const invCols = [
    {
      name: "Invoice Date",
      selector: (row) =>
        !!row?.invDate ? moment(row?.invDate).format(DATE_FORMAT_MOMENT) : "",
      sortable: true,
      // filterable: true,
      // omit: hideColums,
      //
    },
    {
      name: "Invoice No.",
      selector: (row) => row?.invNo,
      sortable: true,
      // filterable: true,
      // omit: hideColums,
    },
    {
      name: "Invoice Amount",
      selector: (row) => row?.amount,
      sortable: true,
      // filterable: true,
      // omit: hideColums,
    },
  ];

  const closePopup = () => {
    setAlertConfig({
      isSuccess: false,
      size: "sm",
      show: false,
      title: "",
      description: "",
    });
    // getCustCn();
  };

  const openModal = (argData) => {
    setOpenModalConfig({
      show: true,
      title: "Bank Slip",
      size: "lg",
      data: argData,
    });
  };

  const handleModalClose = () => {
    setOpenModalConfig({
      size: "lg",
      show: false,
      title: "",
    });
    // getDynamicBtn(false);
    setIsAppovedClicked(false);
    setSelectedBs();
    setErrorObj(JSON.parse(JSON.stringify(initErrObj)));
    setIsRemarkBlank(false);
  };

  const handelActionButtonClick = async (data) => {
    setSpinner(true);
    let bsDtlsResp = await CallApiGet(
      "getBankSlipDetails?bankSlipId=" + data.id + "&custId=" + data.custId
    );

    if (bsDtlsResp.respCode === 200) {
      if (bsDtlsResp.respData.length > 0) {
        let copySelBankSlip = Object.assign({}, bsDtlsResp.respData[0]);
        copySelBankSlip.requestInvAmount = copySelBankSlip.totalInvoiceAmount;
        copySelBankSlip.requestCnAmount = 0;
        copySelBankSlip.remainingCN = 0;
        const fnAmt = copySelBankSlip.totalInvoiceAmount;
        copySelBankSlip.finalAmount = 0;
        setSelectedBs(Object.assign({}, copySelBankSlip));

        selectedBs2 = bsDtlsResp.respData[0];
        setInvoiceList(JSON.parse(bsDtlsResp.respData[0]?.invoice));
        // setFinalAmount(bsDtlsResp.respData[0].totalInvoiceAmount);
        // getDynamicBtn(true, bsDtlsResp.respData[0]);
      }
    }
    setSpinner(false);
    openModal();
  };

  useEffect(() => {
    loadBsList();

    if (searchParams.get("bsId"))
      handelActionButtonClick({
        id: searchParams.get("bsId"),
        custId: searchParams.get("custId"),
      });
    setSearchParams({});
  }, []);

  const loadBsList = async () => {
    setSpinner(true);
    let bsListResp = await CallApiGet("getAllBankSlip");
    if (bsListResp.respCode === 200) {
      if (bsListResp.respData.length > 0) setBsList(bsListResp.respData);
    }
    setSpinner(false);
  };

  const onApproveClick = () => {
    setIsAppovedClicked(true);
    // getDynamicBtn(true, selectedBs2);
  };

  const onRejectClick = async () => {
    setSpinner(true);
    handleModalClose();
    let resp = await CallApiGet("rejectBankSlip?bsId=" + selectedBs.id);
    if (resp.respCode === 200) {
      openPopup(true, "Success", "Bank Slip Rejected");
      loadBsList();
    } else {
      handleApiResponse(resp);
    }
    setSpinner(false);
  };
  const payByCreditVal = (checked) => {
    setCreditNoteApplied(checked);
    if (checked) {
      let amt = selectedBs.totalInvoiceAmount - selectedBs.avlCnAmount;
      if (amt > 0) {
        setFinalAmount(amt.toFixed(2));
      } else setFinalAmount(0);
    } else {
      setFinalAmount(selectedBs.totalInvoiceAmount);
    }
  };

  const isDataValid = () => {
    let message = "";
    if (
      errorObj.invAmt.value &&
      errorObj.cnAmt.value &&
      errorObj.advAmt.value &&
      errorObj.bnkAmt.value
    ) {
      message =
        "Please correct invoice amount and CN amount and advance amount errors.";
    } else if (errorObj.invAmt.value) {
      message = "Please correct invoice amount ";
    } else if (errorObj.advAmt.value) {
      message = "Please correct advance amount ";
    } else if (errorObj.bnkAmt.value) {
      message = "Please correct Bank Slip Amount ";
    } else {
      message = "Please correct CN amount error.";
    }
    setToastMessage(message);
    setShowToast(true);
  };
  const reqInvAmt = () => {
    const cnUsed = selectedBs?.requestCnAmount;
    const advUsed = !!selectedBs?.requestAdvAmount
      ? selectedBs?.requestAdvAmount
      : 0;
    const bankSlip = !!selectedBs?.requestBankSlipAmount
      ? selectedBs?.requestBankSlipAmount
      : 0;

    return bankSlip + cnUsed + advUsed >= selectedBs?.requestInvAmount
      ? selectedBs?.requestInvAmount
      : bankSlip + cnUsed + advUsed;
  };

  const onPayClick = async (id) => {
    if (!validateData().isValid) return;
    // const bsId = selectedBs2?.id;
    // console.log(JSON.stringify(selectedBs));
    let payload = Object.assign({}, selectedBs);
    payload.bsId = payload.id;
    let remark = document.getElementById("pay-remark").value;
    // const cnUsed = !!document.getElementById("pay-by-cn")
    //   ? document.getElementById("pay-by-cn").checked
    //   : false;
    const cnUsed = !!selectedBs?.requestCnAmount
      ? selectedBs?.requestCnAmount > 0
      : false;
    const advUsed = !!selectedBs?.requestAdvAmount
      ? selectedBs?.requestAdvAmount > 0
      : false;
    payload.remark = remark;
    payload.cnUsed = cnUsed;
    payload.requestInvAmount = parseFloat(reqInvAmt()) || 0;
    payload.requestCnAmount = parseFloat(selectedBs?.requestCnAmount) || 0;
    payload.requestAdvAmount = !!selectedBs?.requestAdvAmount
      ? parseFloat(selectedBs.requestAdvAmount) || 0
      : 0;
    payload.requestBankSlipAmount = !!selectedBs?.requestBankSlipAmount
      ? parseFloat(selectedBs.requestBankSlipAmount) || 0
      : 0;
    payload.advUsed = advUsed;
    setIsRemarkBlank(!remark);

    if (
      errorObj.invAmt.value ||
      errorObj.cnAmt.value ||
      errorObj.bnkAmt.value ||
      errorObj.advAmt.value
    ) {
      isDataValid();
      return;
    } else if (!remark) {
      // setToastMessage("Please enter a remark before continuing.");
      // setShowToast(true);
      return;
    } else {
      let resp = await CallApiPost("approveBankSlip", payload);
      if (resp.respCode === 200) {
        openPopup(
          true,
          "Success",
          "Bank Slip Approved and Payment Completed Successfully"
        );
        loadBsList();
        handleModalClose();
      } else {
        handleApiResponse(resp);
      }

      setSpinner(false);
    }
  };

  const validateData = () => {
    let isValid = true;
    let msg = "";
    const cnUsed = parseFloat(selectedBs?.requestCnAmount) || 0;
    const advUsed = !!selectedBs?.requestAdvAmount
      ? parseFloat(selectedBs.requestAdvAmount) || 0
      : 0;

    const payamt = +selectedBs?.requestBankSlipAmount || 0;
    const invAmt = +selectedBs?.totalInvoiceAmount || 0;
    if (payamt >= invAmt && cnUsed > 0 && advUsed > 0) {
      msg =
        "Please enter invoice amount to be less than total bill amount if CN and Advance payment is applied.";
      isValid = false;
    } else if (payamt >= invAmt + cnUsed && advUsed > 0) {
      msg =
        "Please enter invoice amount to be less than total bill amount + CN amount if Advance payment is applied.";
      isValid = false;
    } else if (payamt >= invAmt + advUsed && cnUsed > 0) {
      msg =
        "Please enter invoice amount to be less than total bill amount + Advance payment amount if CN is applied.";
      isValid = false;
    } else if (payamt < invAmt && invAmt < cnUsed + advUsed + payamt) {
      msg = "Total payment amount should be equal to total bill amount.";
      isValid = false;
    }
    if (!isValid) {
      setToastMessage(msg);
      setShowToast(true);
    }
    return { isValid, msg };
  };

  const openPopup = (boolVal, argTitle, argDesc) => {
    setAlertConfig({
      isSuccess: boolVal,
      size: "",
      show: true,
      title: argTitle,
      description: argDesc,
    });
  };
  const handleApiResponse = (resp) => {
    switch (resp.respCode) {
      case 500:
        openPopup(
          false,
          "ERROR",
          "Something went wrong. Please try after sometime!!"
        );
        break;
      case 99:
        openPopup(false, "ERROR", "Network Error!!");
        break;
      default:
        openPopup(false, "ERROR", resp.respMessage);
        break;
    }
  };

  const approveBtn = (
    <>
      <button
        type="button"
        className="btn btn-danger me-2"
        onClick={onRejectClick}
      >
        Reject
      </button>
      <button
        type="button"
        className="btn btn-primary theme-violet"
        onClick={onApproveClick}
      >
        Approve
      </button>
    </>
  );

  const payBtn = (
    <>
      <button
        type="button"
        className="btn btn-danger me-2"
        onClick={onRejectClick}
      >
        Reject
      </button>
      <button
        type="button"
        className="btn btn-primary theme-violet"
        onClick={onPayClick}
        disabled={!selectedBs?.requestBankSlipAmount}
        // disabled={errorObj.invAmt.value || errorObj.cnAmt.value}
      >
        Approved & Paid
      </button>
    </>
  );

  const getDynamicBtn = (isApproved, data) => {
    // if (selectedBs?.statusId === 810) {
    if (!!data && data.statusId === 810 && isApproved) {
      // setFooterButton(payBtn);
      return payBtn;
    } else if (!!data && data.statusId === 810) {
      // setFooterButton(approveBtn);
      return approveBtn;
    } else {
      // setFooterButton("");
      return (
        <button
          type="button"
          className="btn btn-secondary me-2"
          onClick={handleModalClose}
        >
          Close
        </button>
      );
    }
    // }
  };
  const onSuccess = (title, body) => {
    console.log("title", title, "body", body);
  };

  const onError = (errMsg) => {
    console.log("errMsg", errMsg);
  };

  return (
    <>
      <Layout
        spinnershow={spinner}
        alertConfig={alertConfig}
        hideAlert={closePopup}
      >
        <div className="clearfix border-bottom pb-2">
          <div className="float-start">
            <div className="section-title mt-1">Bank Slip Approval</div>
          </div>
        </div>
        <BankSlipList bsColumns={bsCols} bsList={bsList} />
      </Layout>

      {/* <ModalCustom
        confirmAlertConfig={openModalConfig}
        hideConfirmAlert={handleModalClose}
        modalDynamicButtons={footerButton}
        modalStyle={{ titelStyle: "theme-label fs-6 " }}
      >
        <BankSlipDetailes
          selectedBs={selectedBs}
          setSelectedBs={setSelectedBs}
          isAppovedClicked={isAppovedClicked}
          invCols={invCols}
          invoiceList={invoiceList}
          payByCreditVal={payByCreditVal}
          isRemarkBlank={isRemarkBlank}
          setIsRemarkBlank={setIsRemarkBlank}
          errorObj={errorObj}
          setErrorObj={setErrorObj}
        />
      </ModalCustom> */}

      <BankSlipModal
        openModalConfig={openModalConfig}
        handleClose={handleModalClose}
        selectedBs={selectedBs}
        getDynamicBtn={getDynamicBtn}
        modalStyle={{ titelStyle: "theme-label fs-6 " }}
      >
        <BankSlipDetailes
          selectedBs={selectedBs}
          setSelectedBs={setSelectedBs}
          isAppovedClicked={isAppovedClicked}
          invCols={invCols}
          invoiceList={invoiceList}
          payByCreditVal={payByCreditVal}
          isRemarkBlank={isRemarkBlank}
          setIsRemarkBlank={setIsRemarkBlank}
          errorObj={errorObj}
          setErrorObj={setErrorObj}
        />
      </BankSlipModal>
      <div
        style={{
          position: "fixed",
          top: 20,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 9999,
        }}
      >
        <Toast
          style={{
            backgroundColor: "white",
            opacity: 1,
            border: "1px solid #dee2e6",
          }}
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={5000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Error</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </div>
    </>
  );
};

const BankSlipModal = ({
  children,
  openModalConfig,
  handleClose,
  modalStyle,
  selectedBs,
  getDynamicBtn,
}) => {
  return (
    <Modal
      size={openModalConfig.size}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={openModalConfig.show}
      onHide={handleClose}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title className={modalStyle?.titelStyle}>
          {openModalConfig.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>{getDynamicBtn(true, selectedBs)}</Modal.Footer>
    </Modal>
  );
};

export default BankSlipMain;
